<template>
  <v-dialog
    v-model="isVisible"
    max-width="500"
    width="500"
    content-class="more-dialog"
  >
    <v-card class="dialog-card">
      <div class="dialog-card-header">
        <h2>{{ $t(title) }}</h2>
      </div>
      <div class="dialog-card-content">
        <span v-html="$t(message)" />
      </div>
      <div class="dialog-card-footer">
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="confirmed(false)"
          >
            {{ $t('payment_information.txt.no') }}
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="confirmed(true)"
          >
            {{ $t('payment_information.txt.yes') }}
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ServiceConfirmation',
  data: function() {
    return {
      isVisible: false,
      title: '',
      message: ''
    }
  },
  methods: {
    confirmed(choice) {
      this.isVisible = false
      if (choice === true) {
        this.$emit('onConfirmation', choice)
      }
    },
    open({ title, message }) {
      this.isVisible = true

      this.title = title
      this.message = message
    }
  }
}
</script>